import academies from './models/AcademiesHelper';
import certifications from './models/CertificationsHelper';
import certificationBusinessPartners from './models/CertificationBusinessPartnersHelper';
import certificationAuthorities from './models/CertificationAuthoritiesHelper';
import certificationHolders from './models/CertificationHoldersHelper';
import chapters from './models/ChaptersHelper';
import courses from './models/CoursesHelper';
import paths from './models/PathsHelper';
import projects from './models/ProjectsHelper';
import externalResources from './models/ExternalResourcesHelper';
import learningOutcomes from './models/LearningOutcomesHelper';
import categories from './models/CategoriesHelper';
import trainingPrograms from './models/TrainingProgramsHelper';

export default {
  academies,
  certifications,
  certificationAuthorities,
  certificationBusinessPartners,
  certificationHolders,
  chapters,
  courses,
  paths,
  projects,
  externalResources,
  learningOutcomes,
  categories,
  trainingPrograms,
};
